import { SelectOption } from '@touche-lts/panel-ui/dist'
// import { RootStore } from 'mobx-stores'
import { ProductsSKUTableBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { ProductSKUAttributes, ProductSKUsDTO, SKUTableActions, SKUTableSortedBy } from 'models'
import { getSelectOptions } from 'utilities'
import { Api } from 'services'

export class ProductsSKUTableStore extends ProductsSKUTableBase {
  private rootStore:any
  private productsApi: Api['productsApi']
  private totalElementsNumber: number

  constructor (rootStore:any) {
    super()
    this.rootStore = rootStore
    this.productsApi = this.rootStore.generalStore.api.productsApi
  }

  // ACTIONS
  public setTableSKUCheckboxState = (isChecked: boolean, index: number): void => {
    const {
      selectedCheckboxes,
      setEditModeSkuByAction
    } = this.rootStore.productsSKUsStore

    if(!isChecked) {
      selectedCheckboxes.set(index, {...this.searchResults[index]});
    } else {
      selectedCheckboxes.delete(index);
    }
    setEditModeSkuByAction();
    this.searchResults[index].isChecked = !isChecked;
  }

  public setTableSkusAllCheckboxState = (): void => {
    const {
      selectedCheckboxes,
      allCheckedProducts,
      setEditModeSkuByAction
    } = this.rootStore.productsSKUsStore
    this.searchResults.forEach((value: ProductSKUsDTO, index: number) => {
      if(allCheckedProducts) {
        selectedCheckboxes.set(index, {...this.searchResults[index]});
        this.searchResults[index].isChecked = true
      } else {
        selectedCheckboxes.delete(index);
        this.searchResults[index].isChecked = false
      }
    })
    setEditModeSkuByAction();
  }

  public handleNewValueActionApply = async (productId: number | string) => {
    const {
      selectedCheckboxes,
      selectedCheckboxesKeys,
      selectedTableAction,
      resetApplySkuAction,
      setNewValueFromAction,
      newSkuValueInput,
    } = this.rootStore.productsSKUsStore;

    let initialTableSkus: ProductSKUsDTO[] = [...this.searchResults];

    selectedCheckboxesKeys.forEach(indexOfTableSku => { 
      if(selectedTableAction === SKUTableActions.PRICE) {
        initialTableSkus[indexOfTableSku].price = newSkuValueInput;
      } 
      else if(selectedTableAction === SKUTableActions.ARCHIVE) {
        initialTableSkus[indexOfTableSku].status = 'ARCHIVED';
      }
      else {
        initialTableSkus[indexOfTableSku].stock = newSkuValueInput;
      }
    });

    const newTableSkus = await this.productsApi.updateAllProductSkus(productId, initialTableSkus);

    if(!newTableSkus) return
    this.setSearchResults(newTableSkus);
    selectedCheckboxes.clear();
    resetApplySkuAction();
    setNewValueFromAction('');
  }

  public editProductSku = (sku: string, productIndex: number): void => {
    this.searchResults[productIndex].sku = sku;
  }

  public editProductPrice = (price: string, productIndex: number): void => {
    this.searchResults[productIndex].price = price;
  }

  public editProductStock = (stock: string, productIndex: number): void => {
    this.searchResults[productIndex].stock = stock;
  }

  public updateTableSkusOnBlur = async (productId: number | string) => {
    const newTableSkus = await this.productsApi.updateAllProductSkus(productId, this.searchResults);
    if(!newTableSkus) return
    this.setSearchResults(newTableSkus);
  }

  // COMPUTED
  public get skuTableElementsLength (): number {
    return this.searchResults.length
  }

  public get skuTableSortedByOptions (): SelectOption<SKUTableSortedBy>[] {
    return getSelectOptions(SKUTableSortedBy)
  }

  public get skuTableActionsOptions (): SelectOption<SKUTableActions>[] {
    return getSelectOptions(SKUTableActions)
  }

  public get tableSkus (): any[] {
    return this.searchResults
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const { setStoreProps, getProductId } = this.rootStore.viewProductsPageStore,
    skus = await this.rootStore.generalStore.api.productsApi.allFilteredSorted(
      getProductId,
      this.productSKUFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )
    if(!skus) return
    setStoreProps({productSkus: skus.content});
    this.handleSearchResult(skus)
    this.totalElementsNumber = skus.totalElements
  }

  public filterTableSkus = (): void => {
    const {
      getAttributeIdSelected
    } = this.rootStore.productsSKUsStore,
    tableSkuResults = [...this.searchResultsFilter],
    selectedAttr = getAttributeIdSelected.filter(attr => !!attr);

    if(!selectedAttr.length) {
      this.searchResults = tableSkuResults;
      return;
    }
    if(this.totalElementsNumber <=100) {
      this.searchResults = [...tableSkuResults.filter((productSku: ProductSKUsDTO) => {
        const skuAttrIds = productSku.attributes.map((attr: ProductSKUAttributes) => attr.id);
        return selectedAttr.every(attrId => skuAttrIds.includes(attrId))
      })];
    } else {
      // TODO-A CALL BD
    }
  }
}
